import { render } from "./FullscreenLayout.vue?vue&type=template&id=1eff3d05"
import script from "./FullscreenLayout.vue?vue&type=script&lang=ts"
export * from "./FullscreenLayout.vue?vue&type=script&lang=ts"
script.render = render

export default script